module.exports = __webpack_public_path__ + "img/litterAfsorder.b27fd594.svg";